import React, { useState } from 'react';

interface ResponseDisplayProps {
  response: unknown;
  error?: boolean;
  label?: string;
  /** When true, the content is hidden behind an expand/collapse toggle instead of always shown. */
  collapsible?: boolean;
  /** Only relevant when collapsible is true. Defaults to collapsed. */
  defaultExpanded?: boolean;
}

export default function ResponseDisplay({
  response,
  error = false,
  label = 'Response',
  collapsible = false,
  defaultExpanded = false,
}: ResponseDisplayProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  if (!response) return null;

  const content = typeof response === 'string' ? response : JSON.stringify(response, null, 2);

  return (
    <div className="response-container">
      {collapsible ? (
        <button
          type="button"
          onClick={() => setExpanded((current) => !current)}
          className="response-label"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          <span>{expanded ? '▾' : '▸'}</span>
          {label}
        </button>
      ) : (
        <div className="response-label">{label}</div>
      )}
      {(!collapsible || expanded) && (
        <pre className={`response-content ${error ? 'response-error' : ''}`}>{content}</pre>
      )}
    </div>
  );
}
